import { useGetProposal } from '@/api/queries/proposal/useGetProposal';
import { useSelector } from '@/api/state';
import { getIsDownloadingFileByJobId } from '@/utils/stateAccessors';
import * as fileDownloadActions from '@payaca/store/fileDownload/fileDownloadActions';
import { FileDownloadTypes } from '@payaca/types/fileDownloadTypes';
import { downloadPdfData } from '@payaca/utilities/fileUtilities';
import { useDispatch } from 'react-redux';

/**
 * Downloads the Proposal as the PDF the Customer is sent.
 *
 * A Proposal shares the legacy `jobs` row, so the download goes through the
 * legacy file-download saga keyed on the numeric job id — which is why this is
 * redux rather than a query hook, and why `canDownload` is false until the
 * Proposal resolves.
 */
export const useDownloadProposalPdf = (proposalId: string) => {
  const dispatch = useDispatch();
  const { proposal } = useGetProposal(proposalId);

  const numericJobId = proposal?.id ? Number(proposal.id) : undefined;

  const isDownloading = useSelector((state) =>
    getIsDownloadingFileByJobId(state, numericJobId, FileDownloadTypes.QUOTE)
  );

  const downloadPdf = () => {
    if (!numericJobId) return;

    const reference = proposal?.customReference ?? proposal?.reference;
    dispatch(
      fileDownloadActions.requestDownloadFile(
        numericJobId,
        FileDownloadTypes.QUOTE,
        (fileContent) => {
          downloadPdfData(fileContent, `proposal_${reference}.pdf`);
        }
      )
    );
  };

  return { downloadPdf, isDownloading, canDownload: !!numericJobId };
};
